module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/get_red_bag.gif";